import {useCallback,useEffect,useMemo,useState} from 'react';
import {api} from './api';
import {OperationRetry} from './operationRetry';
import {DurablePublicationIntent,type PublicationCommand} from './durablePublicationIntent';
import {queryCache} from './queryCache';

export function useOperationRetry(options?:{durable:{userId:string;resourceId:string}}){
  const userId=options?.durable.userId,resourceId=options?.durable.resourceId;
  const context=useMemo(()=>({active:true,controller:userId!==undefined&&resourceId!==undefined?new DurablePublicationIntent({userId,resourceId,storage:{getItem:key=>window.localStorage.getItem(key),setItem:(key,value)=>window.localStorage.setItem(key,value),removeItem:key=>window.localStorage.removeItem(key)}}):new OperationRetry()}),[userId,resourceId]);
  const {controller}=context;const [,render]=useState(0);
  useEffect(()=>{
    context.active=true;
    const unsubscribe=queryCache.subscribe(event=>{if(event!=='invalidate'){controller.reset();render(n=>n+1)}});
    const storageChanged=(event:StorageEvent)=>{if(controller instanceof DurablePublicationIntent&&(event.key===controller.key||event.key===null)){controller.refresh();render(n=>n+1)}};
    window.addEventListener('storage',storageChanged);
    return()=>{context.active=false;unsubscribe();window.removeEventListener('storage',storageChanged);controller.reset()};
  },[context,controller]);
  const exclusive=useCallback(async <T,>(work:()=>Promise<T>)=>{
    const guarded=()=>{if(!context.active)throw new Error('Adgangen er ændret. Hent indholdet igen.');return work()};
    // Serialize the read/store/send sequence across tabs where Web Locks is available.
    if(controller instanceof DurablePublicationIntent&&typeof navigator!=='undefined'&&navigator.locks)return navigator.locks.request(controller.key,guarded);
    return guarded();
  },[context,controller]);
  const run=useCallback(async <T,>(next?:PublicationCommand)=>{
    try{return await exclusive(()=>controller.run<T>(api,next))}finally{if(context.active)render(n=>n+1)}
  },[context,controller,exclusive]);
  const recover=useCallback(async <TJob,>()=>{
    try{return await exclusive(()=>controller instanceof DurablePublicationIntent?controller.recover<TJob>(api):Promise.resolve(null))}finally{if(context.active)render(n=>n+1)}
  },[context,controller,exclusive]);
  return {pending:controller.pending,run,recover};
}
